<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="2">
          <el-step title="海运信息"></el-step>
          <el-step title="增值服务"></el-step>
          <el-step title="托运信息"></el-step>
          <el-step title="确认委托"></el-step>
          <el-step title="委托完成"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <div
          style="display: flex; display: -webkit-flex; align-items: center"
        ></div>
        <div class="Item_list">
          <!-- 委托信息 -->
          <div
            style="
              display: flex;
              display: -webkit-flex;
              align-items: center;
              margin-bottom: 20px;
            "
          >
            <img src="../../assets/weituo.png" alt="委托信息" />
            <p class="tittype">委托信息</p>
          </div>
          <el-row :gutter="20">
            <el-form :label-position="labelPosition" label-width="70px">
              <el-col :span="10">
                <el-form-item label="联系人">
                  <el-input
                    disabled
                    :value="Authorization.customerContact"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="联系电话">
                  <el-input
                    disabled
                    :value="Authorization.customerTel"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="委托公司">
                  <el-input disabled :value="Authorization.namec"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="业务员">
                  <el-input
                    disabled
                    :value="Authorization.salesName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" v-if="todoordate">
                <el-form-item label="提货时间">
                  <el-date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    disabled
                    placeholder="选择日期"
                    v-model="todoordate"
                    style="width: 100%"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="入仓时间">
                  <el-date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    v-model="inwarehousetime"
                    style="width: 100%"
                    :picker-options="pickerSetTime"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
        <div class="Item_list" style="" v-show="countLIst_T.name != ''">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/tihuo.png" alt="提货信息" />
              <p class="tittype" style="color: #333">提货信息</p>
            </div>
            <!-- <span style="float: right"
              ><el-button
                @click="addNewpop(2)"
                type="text"
                style="color: #FF4D01"
                >新增提货人</el-button
              ></span
            > -->
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <!-- 当前展示的联系人 -->
            <div
              class="thatpoperWrap"
              v-show="countLIst_T.name"
              style="margin-top: 20px"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ countLIst_T.name }}</p>
                <p style="margin-left: 12px">{{ countLIst_T.tel }}</p>
                <p class="overText" style="margin-left: 20px">
                  {{ countLIst_T.parvince }}{{ countLIst_T.city
                  }}{{ countLIst_T.area }}{{ countLIst_T.address }}
                </p>
              </div>
              <!-- <div class="popWrap_R">
                <span class="morentype" v-show="countLIst_T.isdefault"
                  >默认地址</span
                >
                <el-button
                  v-show="!countLIst_T.isdefault"
                  style="color: #FF4D01"
                  type="text"
                  @click.stop="changeshowType(2, countLIst_T, 'loca')"
                  >设为默认地址</el-button
                >
                <el-button
                  style="color: #FF4D01"
                  type="text"
                  @click.stop="UpItem(2, countLIst_T)"
                  >修改</el-button
                >
              </div> -->
            </div>
            <el-collapse-transition>
              <div v-show="showTi">
                <div
                  class="poperWrap"
                  style="margin-top: 20px"
                  v-for="(item, index) in TipopList"
                  :key="index"
                  @click="changeTiitem(item)"
                >
                  <div class="popWrap_l">
                    <p class="lianxiren">{{ item.name }}</p>
                    <p style="margin-left: 12px">{{ item.tel }}</p>
                    <p class="overText" style="margin-left: 20px">
                      {{ item.parvince }}{{ item.city }}{{ item.area
                      }}{{ item.address }}
                    </p>
                  </div>
                  <div class="popWrap_R">
                    <span class="morentype" v-show="item.isdefault"
                      >默认地址</span
                    >
                    <el-button
                      v-show="!item.isdefault"
                      style="color: #FF4D01"
                      type="text"
                      @click.stop="changeshowType(2, item, 'ajax')"
                      >设为默认地址</el-button
                    >
                    <el-button
                      style="color: #FF4D01"
                      type="text"
                      @click.stop="UpItem(2, item)"
                      >修改</el-button
                    >
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <!-- <div style="margin: 10px 0 0 30px" v-show="TipopList.length > 1">
            <el-button @click="openmo2()" style="color: #9a9a9a" type="text">{{
              showTi ? "收起更多" : "更多提货人信息"
            }}</el-button
            ><span
              :class="showTi ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></span>
          </div> -->
        </div>
        <!-- 收货信息地址 -->
        <div class="Item_list">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/shouhuo.png" alt="收货信息" />
              <p class="tittype">收货信息</p>
            </div>
            <span v-if="!PSFmoney.checked" style="float: right"
              ><el-button
                @click="addNewpop(3)"
                type="text"
                style="color: #FF4D01"
                >新增收货人</el-button
              ></span
            >
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <div class="poperWrap" v-show="countLIst_C.name == ''">
              暂无默认联系人请添加
            </div>
            <!-- 当前展示的联系人 -->
            <div
              class="thatpoperWrap"
              v-show="countLIst_C.name"
              style="margin-top: 20px"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ countLIst_C.name }}</p>
                <p style="margin-left: 12px">{{ countLIst_C.tel }}</p>
                <p class="overText" style="margin-left: 20px">
                  {{ countLIst_C.country }}{{ countLIst_C.city
                  }}{{ countLIst_C.area }}{{ countLIst_C.address }}
                </p>
              </div>
              <div class="popWrap_R">
                <!-- <span class="morentype" v-show="countLIst_C.isdefault"
                  >默认地址</span
                > -->
                <!-- <el-button
                  v-show="!countLIst_C.isdefault"
                  style="color: #FF4D01"
                  type="text"
                  @click.stop="changeshowType(3, countLIst_C, 'loca')"
                  >设为默认地址</el-button
                >
                <el-button
                  style="color: #FF4D01"
                  type="text"
                  @click.stop="UpItem(3, countLIst_C)"
                  >修改</el-button
                > -->
              </div>
            </div>
            <el-collapse-transition>
              <div v-show="showSh">
                <div
                  class="poperWrap"
                  style="margin-top: 20px"
                  v-for="(item, index) in SHpopList"
                  :key="index"
                  @click="changeShitem(item)"
                >
                  <div class="popWrap_l">
                    <p class="lianxiren">{{ item.name }}</p>
                    <p style="margin-left: 12px">{{ item.tel }}</p>
                    <p class="overText" style="margin-left: 20px">
                      {{ item.country }}{{ item.city }}{{ item.area
                      }}{{ item.address }}
                    </p>
                  </div>
                  <div class="popWrap_R">
                    <span class="morentype" v-show="item.isdefault"
                      >默认地址</span
                    >
                    <el-button
                      v-show="!item.isdefault"
                      style="color: #FF4D01"
                      type="text"
                      @click.stop="changeshowType(3, item, 'ajax')"
                      >设为默认地址</el-button
                    >
                    <el-button
                      style="color: #FF4D01"
                      type="text"
                      @click.stop="UpItem(3, item)"
                      >修改</el-button
                    >
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div
            style="margin: 10px 0 0 30px"
            v-show="SHpopList.length > 1 && !PSFmoney.checked"
          >
            <el-button @click="openmo3()" style="color: #9a9a9a" type="text">{{
              showSh ? "收起更多" : "更多收货人信息"
            }}</el-button
            ><span
              :class="showSh ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></span>
          </div>
        </div>
        <div class="Item_list" style="padding: 0" v-if="!tuoCheData.checked">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div
              class=""
              style="width: 100%; background: #ffe9c7; padding: 8px 30px"
            >
              <p
                class="tittype"
                style="padding: 0 5px; color: #c19822; font-size: 16px"
              >
                请将货物送至以下仓库
              </p>
            </div>
          </div>
          <div style="width: 100%; box-sizing: border-box">
            <div
              class="thatpoperWrap"
              style="padding: 30px 50px; border: none; background: #ffffff"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ cangkuitem.namec }}</p>
                <p style="margin-left: 12px">{{ cangkuitem.tel }}</p>
                <p class="" style="margin-left: 20px">
                  {{ cangkuitem.country }}{{ cangkuitem.addressc }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 提货仓库地址 -->
        <div class="Item_list" style="padding: 0" v-if="!PSFmoney.checked">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div
              class=""
              style="width: 100%; background: #ffe9c7; padding: 8px 30px"
            >
              <p
                class="tittype"
                style="padding: 0 5px; color: #c19822; font-size: 16px"
              >
                请到以下目的地仓库提取货物
              </p>
            </div>
          </div>
          <div style="width: 100%; box-sizing: border-box">
            <div
              class="thatpoperWrap"
              style="padding: 30px 50px; border: none; background: #ffffff"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ description.namec }}</p>
                <p style="margin-left: 12px">{{ description.tel }}</p>
                <p class="" style="margin-left: 20px">
                  {{ description.addressc }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 发货信息地址 -->
        <!-- <div class="Item_list">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/fahuo.png" alt="" />
              <p class="tittype">发货信息</p>
            </div>
            <span style="float: right"
              ><el-button
                @click="addNewpop(1)"
                type="text"
                style="color: #FF4D01"
                >新增发货人</el-button
              ></span
            >
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <div class="poperWrap" v-show="countLIst_S.name == ''">
              暂无默认联系人请添加
            </div>
            <div
              class="thatpoperWrap"
              v-show="countLIst_S.name"
              style="margin-top: 20px"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ countLIst_S.name }}</p>
                <p style="margin-left: 12px">{{ countLIst_S.tel }}</p>
              </div>
              <div class="popWrap_R">
                <span class="morentype" v-show="countLIst_S.isdefault"
                  >默认地址</span
                >
                <el-button
                  v-show="!countLIst_S.isdefault"
                  style="color: #FF4D01"
                  type="text"
                  @click.stop="changeshowType(1, countLIst_S, 'loca')"
                  >设为默认地址</el-button
                >
                <el-button
                  style="color: #FF4D01"
                  type="text"
                  @click="UpItem(1, countLIst_S)"
                  >修改</el-button
                >
              </div>
            </div>
            <el-collapse-transition>
              <div v-show="showFa">
                <div
                  class="poperWrap"
                  style="margin-top: 20px"
                  v-for="(item, index) in FapopList"
                  :key="index"
                  @click="changeFAitem(item)"
                >
                  <div class="popWrap_l">
                    <p class="lianxiren">{{ item.name }}</p>
                    <p style="margin-left: 12px">{{ item.tel }}</p>
                  </div>
                  <div class="popWrap_R">
                    <span class="morentype" v-show="item.isdefault"
                      >默认地址</span
                    >
                    <el-button
                      v-show="!item.isdefault"
                      style="color: #FF4D01"
                      type="text"
                      @click.stop="changeshowType(1, item, 'ajax')"
                      >设为默认地址</el-button
                    >
                    <el-button
                      style="color: #FF4D01"
                      type="text"
                      @click.stop="UpItem(1, item)"
                      >修改</el-button
                    >
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div style="margin: 10px 0 0 30px" v-show="FapopList.length > 1">
            <el-button @click="openmo1()" style="color: #9a9a9a" type="text">{{
              showFa ? "收起更多" : "更多发货人信息"
            }}</el-button
            ><span
              :class="showFa ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></span>
          </div>
        </div> -->

        <!-- 备注item -->
        <div class="Item_list">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/ps.png" alt="备注" />
              <p class="tittype">备注</p>
            </div>
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <!-- 当前展示的联系人 -->
            <div style="margin-top: 20px">
              <div class="popWrap_l">
                <el-form style="width: 100%" ref="form" label-width="80px">
                  <el-form-item label="发货备注">
                    <el-input
                      style="width: 100%"
                      v-model="delgoodsremarks"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收货备注">
                    <el-input v-model="recgoodremarks"></el-input>
                  </el-form-item>
                  <el-form-item v-if="tuoCheData.checked" label="提货备注">
                    <el-input v-model="getgoodsremarks"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <!-- item结束 -->
      </div>
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #343434;
          "
        >
          费用计算
        </p>
        <div class="OrderDetails">
          <div class="Item_Right animate__animated animate__bounceInRight">
            <p class="tit">海运费</p>
            <p
              class="coutText"
              v-for="(item, index) in HYFmoney.goodsTypeFeeDTOS"
              :key="index"
            >
              <span class="littit">{{ item.goodsTypeName }}</span>
              <span class="fontString"
                >{{ item.currency }}{{ item.amount }}</span
              >
              <span style="margin-left:10px">({{item.calDesc}})</span>
            </p>
            <p class="coutText">
              <span class="littit">小计</span>
              <span class="fontString"
                >{{ HYFmoney.currency }}{{ HYFmoney.amount }}</span
              >
              
            </p>
          </div>
          <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-show="tuoCheData.checked"
          >
            <p class="tit">提货费<span v-if="tuoCheData.minKilometer" style="font-size:13px;float: right;font-weight: 500;">({{tuoCheData.minKilometer+'KM'}}--{{tuoCheData.maxKilometer+'KM'}})</span></p>
            <p class="coutText">
              <span class="littit">发货地上门提货</span>
              <span class="fontString"
                >{{ tuoCheData.currency }}{{ tuoCheData.amount }}</span
              >
            </p>
          </div>
          <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-show="PSFmoney.checked"
          >
            <p class="tit">配送费</p>
            <p class="coutText">
              <span class="littit">目的地送货上门</span>
              <span class="fontString"
                >{{ PSFmoney.currency }}{{ PSFmoney.amount }}</span
              >
            </p>
          </div>
          <div class="Item_Right">
            <p class="tit">增值服务费</p>
            <div
              class="coutText animate__animated animate__bounceInRight"
              v-for="(item, index) in formData"
              :key="index"
              v-show="item.checked"
            >
              <span class="littit">{{ item.feeName }}</span>
              <span class="fontString">{{ item.currency }}{{ item.amount }}
                <span v-if="item.feeCode=='CLEF'">({{item.basePrice}}+{{item.cnycontinuationPrice}}*{{item.piece}}</span>
                <span v-else>({{ item.piece }}*{{item.price}}</span>
                <span class="fontString" v-show="item.feeUnit">{{item.feeUnit}}</span>)</span>
            </div>
          </div>
          <div class="Item_Right">
            <p class="coutText">
              <span class="littit">合计费用</span>
              <span
                class="fontString"
                v-for="(item, index) in this.newArray"
                :key="index"
                v-show="item.amount > 0"
              >
                <span v-show="item.currency != ''">{{ item.currency }}</span>
                <span
                  class="fontString"
                  v-show="item.amount > 0"
                  style="margin-left: 5px; margin-right: 5px"
                  >{{ item.amount }}</span
                >
                <span v-show="index == newArray.length - 1 ? false : true"
                  >+</span
                >
              </span>
            </p>
            <p class="coutText">
              <span class="littit">折合人民币</span>
              <span class="fontString">CNY {{ calculatePrice }}</span>
            </p>
          </div>
        </div>

        <div style="width: 100%; margin-top: 30px; float: left">
          <div style="width: 100%">
            <el-button style="width: 100%" @click="pathToback()"
              >上一步</el-button
            >
          </div>
          <div style="width: 100%; margin-top: 10px">
            <el-button
              @click="pathToNext()"
              style="width: 100%; background: #FF4D01; color: #ffffff"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
      <el-dialog
        class="dialog"
        :width="width"
        :visible.sync="dialogTableVisible"
        :closeOnClickModal="false"
      >
        <div class="wrap_count">
          <div class="header_logo">
            {{ !this.itemid ? "新增地址" : "修改地址" }}
          </div>
          <div class="count">
            <el-form :label-position="labelPosition" label-width="80px">
              <el-form-item label="联系人">
                <el-input
                  placeholder="请输入姓名"
                  v-model="fromPop.name"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系方式">
                <el-input
                  placeholder="请输入联系方式"
                  v-model="fromPop.tel"
                ></el-input>
              </el-form-item>
              <!-- 国内省市区 -->
              <el-form-item label="联系地址" v-show="changeNum == 2">
                <el-cascader
                  style="width: 100%"
                  ref="refSsqname"
                  :options="Guojialist"
                  v-model="ssqnames"
                  @change="changessq"
                  :props="defaultParams"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.namec }}</span>
                    <span v-if="!node.isLeaf"></span>
                  </template>
                </el-cascader>
              </el-form-item>
              <!-- 国外区域 -->
              <el-form-item label="联系地址" v-show="changeNum == 3">
                <el-cascader
                  style="width: 100%"
                  ref="refSsqname"
                  :options="citylist"
                  v-model="ssqnames"
                  @change="changessq"
                  :props="defaultParams"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.namec }}</span>
                    <span v-if="!node.isLeaf"></span>
                  </template>
                </el-cascader>
              </el-form-item>
              <el-form-item v-show="changeNum != 1">
                <el-input
                  placeholder="请输入详细地址"
                  type="textarea"
                  v-model="fromPop.address"
                ></el-input>
              </el-form-item>
              <el-form-item prop="type">
                <el-checkbox-group v-model="fromPop.isdefault">
                  <el-checkbox name="type">设置为默认地址</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">{{
                  itemid ? "修改" : "确定新增"
                }}</el-button>
                <el-button @click="dialogTableVisible = false">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import {mapState} from "vuex";
export default {
  data() {
    return {
      getgoodsremarks: "",
      recgoodremarks: "",
      delgoodsremarks: "",
      inwarehousetime: "",
      description: JSON.parse(sessionStorage.getItem("PScangkuitem")),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerSetTime: {
        disabledDate(time) {
          if (sessionStorage.getItem("todoorTime")) {
            return time.getTime() < Date.now();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      disabledTime: sessionStorage.getItem("todoorTime") ? true : false,
      countLIst_S: {
        //发货
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      countLIst_T: {
        //提货
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
        parvince: "",
        area: "",
      },
      countLIst_C: {
        //收货
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      itemid: "",
      changeNum: null, //1 发货 2提货3收货
      ssqnames: [],
      citylist: [],
      Guojialist: [],
      defaultParams: {
        //定义 联级选择器的 -省市区-和-收货地址-需获取name
        label: "namec",
        value: "namec",
        children: "children",
      },
      fromPop: {
        address: "",
        parvince: "",
        city: "",
        area: "",
        country: "",
        customerid: null,
        id: "",
        isdefault: true,
        name: "",
        tag: "",
        tel: "",
      },
      isdefault: true,
      labelPosition: "left",
      addUserData: {},

      dialogTableVisible: false,
      width: "420px",
      showFa: false,
      showTi: false,
      showSh: false,
      FapopList: [],
      TipopList: [],
      SHpopList: [],
      todoordate: null,
      labelPosition: "left",
      moneytype: [],
      formData: [],
      auto_fixed: false,
      Citydata: null,
      cangkuitem: null,
      guojiaData: null,
      HYFmoney: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      PSFmoney: {
        checked: true,
        name: "配送费",
        feeCode: "SDYF",
        feeType: "A",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      msgFormSon: {},
      newTihuoarr: "", //需展示的提货地址
      tuoCheData: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
      },
    };
  },
  watch: {},
  computed: {
    ...mapState(['Authorization']),
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let PSFmoney = 0; //配送费
      let HYFmoney = 0; //海运费
      let THFmoney = 0; //提货费
      let feemoney = 0; //增值服务
      this.formData.forEach((item) => {
        if (item.checked) {
          feemoney += Number(item.cnyamount);
        }
      });
      if (this.PSFmoney.checked) {
        //如果有配送费
        PSFmoney = this.PSFmoney.cnyamount ? +this.PSFmoney.cnyamount : 0;
      }
      if (this.tuoCheData.checked) {
        //如果有提货费
        THFmoney = this.tuoCheData.cnyamount ? +this.tuoCheData.cnyamount : 0;
      }
      HYFmoney = this.HYFmoney.cnyamount ? +this.HYFmoney.cnyamount : 0;
      Totalmoney = PSFmoney + HYFmoney + THFmoney + feemoney;
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.HYFmoney))); //海运费币种
      if (this.PSFmoney.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.PSFmoney))); //配送费币种
      }
      if (this.tuoCheData.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.tuoCheData))); //提货费费币种
      }
      this.formData.forEach((item) => {
        if (item.checked) {
          totalFeiyong.push(JSON.parse(JSON.stringify(item)));
        }
      });
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
  },
  methods: {
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    changeshowType(num, item, type) {
      console.log(num);
      //设为默认
      this.axios
        .post(
          `/customer/updateAddressDefault?${qs.stringify({
            addressId: item.id,
          })}`
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            num == 1
              ? this.getFadata()
              : num == 2
              ? this.getTidata()
              : this.getSHdata();
            this.$message({ message: "成功", type: "success" });
          } else {
            this.$message(res.data.message);
          }
        });
      if (num == 1 && type == "loca") {
        item.isdefault = true;
        let countLIst_S = JSON.parse(sessionStorage.getItem("countLIst_S"));
        countLIst_S.isdefault = true;
        sessionStorage.setItem("countLIst_S", JSON.stringify(countLIst_S));
      } else if (num == 2 && type == "loca") {
        item.isdefault = true;
        let countLIst_T = JSON.parse(sessionStorage.getItem("countLIst_T"));
        countLIst_T.isdefault = true;
        sessionStorage.setItem("countLIst_T", JSON.stringify(countLIst_T));
      } else if (num == 3 && type == "loca") {
        item.isdefault = true;
        let countLIst_C = JSON.parse(sessionStorage.getItem("countLIst_C"));
        countLIst_C.isdefault = true;
        sessionStorage.setItem("countLIst_C", JSON.stringify(countLIst_C));
      }
    },
    onSubmit() {
      console.log(this.changeNum);
      let that = this;
      //changeNum //1 发货 2提货3收货
      if (!this.fromPop.name) return this.$message("请输入联系人姓名");
      if (!this.fromPop.tel) return this.$message("请输入联系人电话");
      if (this.changeNum == 1) {
        //新增发货
        let params = {
          customerid: this.Authorization
            .customerid, //客户id
          id: this.itemid,
          isdefault: this.fromPop.isdefault,
          name: this.fromPop.name,
          tag: "",
          tel: this.fromPop.tel,
        };
        this.axios.post(`/customer/addOrUpdateShipper`, params).then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.$message({ message: "成功", type: "success" });
            if (this.countLIst_S.id == this.itemid) {
              //为了更新本地默认通讯录信息
              this.countLIst_S = params;
              sessionStorage.setItem("countLIst_S", JSON.stringify(params));
            }
            this.getFadata();
            this.dialogTableVisible = false;
          } else {
            this.$message(res.data.message);
          }
        });
      } else if (this.changeNum == 2) {
        if (this.ssqnames.length == 0) return this.$message("请选择联系地址");
        if (!this.fromPop.address) return this.$message("请输入详细地址");
        let params = {
          customerid: this.Authorization
            .customerid, //客户id
          id: this.itemid,
          isdefault: this.fromPop.isdefault,
          name: this.fromPop.name,
          tag: "",
          tel: this.fromPop.tel,
          parvince: this.ssqnames[0],
          city: this.ssqnames[1],
          area: this.ssqnames[2],
          address: this.fromPop.address,
        };
        this.axios.post(`/customer/addOrUpdateDelivery`, params).then((res) => {
          if (res.data.code == "200") {
            this.$message({ message: "成功", type: "success" });
            this.getTidata();
            this.dialogTableVisible = false;
          } else {
            this.$message(res.data.message);
          }
        });
      } else {
        //新增或修改收货人
        if (this.ssqnames.length == 0) return this.$message("请选择联系地址");
        if (!this.fromPop.address) return this.$message("请输入详细地址");
        let params = {
          customerid: this.Authorization
            .customerid, //客户id
          id: this.itemid,
          isdefault: this.fromPop.isdefault,
          name: this.fromPop.name,
          tag: "",
          tel: this.fromPop.tel,
          country: this.ssqnames[0],
          city: this.ssqnames[1],
          area: this.ssqnames[2],
          address: this.fromPop.address,
          //为了保存到本地赋值
          countryId: this.fromPop.countryId,
          cityId: this.fromPop.cityId,
          areaId: this.fromPop.areaId,
        };
        this.axios
          .post(`/customer/addOrUpdateConsigner`, params)
          .then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.$message({ message: "成功", type: "success" });
              if (this.countLIst_C.id == this.itemid) {
                //为了更新本地默认通讯录信息
                this.countLIst_C = params;
                sessionStorage.setItem("countLIst_C", JSON.stringify(params));
              }
              this.getSHdata();
              this.dialogTableVisible = false;
            } else {
              this.$message(res.data.message);
            }
          });
      }
    },
    changeFAitem(item) {
      this.showFa = false;
      this.countLIst_S = item;
      sessionStorage.setItem("countLIst_S", JSON.stringify(item));
    },
    changeTiitem(item) {
      console.log(item);
      this.showTi = false;
      this.countLIst_T = item;
      sessionStorage.setItem("countLIst_T", JSON.stringify(item));
    },
    changeShitem(item) {
      console.log(item);
      this.showSh = false;
      this.countLIst_C = item;
      sessionStorage.setItem("countLIst_C", JSON.stringify(item));

      // this.getPSFcount(); //重新计算配送费
    },
    // getPSFcount() {
    //   //获取配送费 送货上门
    //   this.loadin = true;
    //   let that = this;
    //   let params = {
    //     customerId: this.Authorization
    //       .customerid, //客户id
    //     feeCode: "SDYF",
    //     podlandId: sessionStorage.getItem("countLIst_C")
    //       ? JSON.parse(sessionStorage.getItem("countLIst_C")).countryId
    //       : "", //目的国id
    //     podlandCityId: sessionStorage.getItem("countLIst_C")
    //       ? JSON.parse(sessionStorage.getItem("countLIst_C")).cityId
    //       : "", //目的城市id
    //     podlandAreaId: sessionStorage.getItem("countLIst_C")
    //       ? JSON.parse(sessionStorage.getItem("countLIst_C")).areaId
    //       : "", //目的区域id
    //     toWarehouseId: sessionStorage.getItem("countLIst_C")
    //       ? JSON.parse(sessionStorage.getItem("PScangkuitem")).id
    //       : "",
    //     sendSecond: "N",
    //   };
    //   this.axios
    //     .post(`/feeitem/getVASPriceForDelivery`, params)
    //     .then((res) => {
    //       console.log(res);
    //       that.PSFmoney.price = res.data.data.price;
    //       that.PSFmoney.currency = res.data.data.currency; //币种
    //       that.PSFmoney.cnycurrency = res.data.data.cnycurrency; //币种
    //       that.PSFmoney.cnyprice = res.data.data.cnyprice; //单价
    //       that.PSFmoney.cnyamount = res.data.data.cnyprice;
    //       that.PSFmoney.amount = res.data.data.price;
    //       that.PSFmoney.piece = 1;
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },
    UpItem(num, item) {
      console.log(num);
      this.itemid = item.id;
      this.getProvinces(num);
      this.ssqnames = [];
      this.changeNum = num;
      this.dialogTableVisible = true;
      this.fromPop = JSON.parse(JSON.stringify(item));
      console.log(this.fromPop);
      if (num == 2) {
        this.ssqnames[0] = item.parvince;
        this.ssqnames[1] = item.city;
        this.ssqnames[2] = item.area;
      } else if (num == 3) {
        this.ssqnames[0] = item.country;
        this.ssqnames[1] = item.city;
        this.ssqnames[2] = item.area;
      }
    },
    addNewpop(num) {
      this.itemid = "";
      this.changeNum = num;
      this.fromPop.name = "";
      this.fromPop.tel = "";
      this.ssqnames = [];
      this.fromPop.address = "";
      this.dialogTableVisible = true;
      if (num != "1") {
        //1是发货人 没有省市区
        this.getProvinces(num); //查询省市区
      }
    },
    getProvinces(num) {
      //获取省市区和国外地址
      let url = "";
      let that = this;
      if (num == 3) {
        //国外城市和区域 2是国外 3是国内
        url = "/filedata/findThirdLevelAddress";
        this.axios
          .post(url)
          .then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.citylist = res.data.datas;
            } else {
            }
          })
          .catch((res) => {
            console.log(res);
          });
      } else {
        //国内省市区
        url = "/filedata/filedataProvinces";
        this.axios
          .post(url)
          .then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.Guojialist = res.data.datas;
            } else {
            }
          })
          .catch((res) => {
            console.log(res);
          });
      }
    },
    changessq(e) {
      //省市区
      console.log(this.ssqnames);
    },
    pathToback() {
      this.$router.go(-1);
    },
    pathToNext() {
      if (!this.inwarehousetime)
        return this.$message({
          showClose: true,
          message: "请选择入仓时间",
        });
      if (this.countLIst_C.name == "")
        return this.$message({
          showClose: true,
          message: "请选择或添加收货信息",
        });
      let params = {};
      let that = this;
      params = {
        recgoodsCountry: this.countLIst_C.country,
        toWarehouseId: this.description.id,
      };
      this.axios
        .post(
          `/busLcljobsBefore/validateWarehouseCountry`,
          qs.stringify(params)
        )
        .then((res) => {
          if (res.data.code == "200") {
            this.$router.push({
              name: "Qdbill",
            });
          } else {
            this.$alert(res.data.message, "错误", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$message({
                  type: "info",
                  message: `请重新选择送货上门地址`,
                });
              },
            });
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });
      sessionStorage.setItem("countLIst_C", JSON.stringify(this.countLIst_C));
      sessionStorage.setItem("inwarehousetime", this.inwarehousetime); //入仓时间

      sessionStorage.setItem(
        "getgoodsremarks",
        JSON.stringify(this.getgoodsremarks)
      ); //备注
      sessionStorage.setItem(
        "recgoodremarks",
        JSON.stringify(this.recgoodremarks)
      ); //备注
      sessionStorage.setItem(
        "delgoodsremarks",
        JSON.stringify(this.delgoodsremarks)
      ); //备注
    },

    openmo1() {
      this.showFa = !this.showFa;
    },
    openmo2() {
      this.showTi = !this.showTi;
    },
    openmo3() {
      this.showSh = !this.showSh;
    },
    getFadata() {
      //发货人
      let that = this;
      let customerId = this.Authorization
        .customerid;
      this.axios
        .get(`/customer/addressListForShipper/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.FapopList = res.data.datas;
            if (sessionStorage.getItem("countLIst_S")) {
              //如果有选择收货费
              this.countLIst_S = JSON.parse(
                sessionStorage.getItem("countLIst_S")
              );
            } else {
              res.data.datas.forEach((item) => {
                if (item.isdefault) {
                  this.countLIst_S = item;
                }
              });
            }
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getTidata() {
      //提货人
      let that = this;
      let customerId = this.Authorization
        .customerid;
      this.axios
        .get(`/customer/addressListForDelivery/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.TipopList = res.data.datas;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getSHdata() {
      //收货人
      let that = this;
      let customerId = this.Authorization
        .customerid;
      this.axios
        .get(`/customer/addressListForConsigner/${customerId}`)
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.SHpopList = res.data.datas;
            if (sessionStorage.getItem("countLIst_C")) {
              //如果有选择收货费
              this.countLIst_C = JSON.parse(
                sessionStorage.getItem("countLIst_C")
              );
            } else {
              //如果没有选择就显示默认
              res.data.datas.forEach((item) => {
                if (item.isdefault) {
                  this.countLIst_C = item;
                }
              });
            }
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
  },
  created() {
    this.Citydata = JSON.parse(sessionStorage.getItem("Citydata"));
    this.cangkuitem = JSON.parse(sessionStorage.getItem("cangkuitem"));
    this.guojiaData = JSON.parse(sessionStorage.getItem("guojiaData"));

    this.getgoodsremarks = JSON.parse(sessionStorage.getItem("getgoodsremarks"));
    this.recgoodremarks = JSON.parse(sessionStorage.getItem("recgoodremarks"));
    this.delgoodsremarks = JSON.parse(sessionStorage.getItem("delgoodsremarks"));

    if (sessionStorage.getItem("HYFmoney")) {
      //海运费
      this.HYFmoney = JSON.parse(sessionStorage.getItem("HYFmoney"));
    }
    if (JSON.parse(sessionStorage.getItem("PSFmoney"))) {
      //配送费
      this.PSFmoney = JSON.parse(sessionStorage.getItem("PSFmoney"));
    }
    if (sessionStorage.getItem("todoordate")) {
      //提货费
      this.tuoCheData = JSON.parse(sessionStorage.getItem("todoordate"));
    }
    if (sessionStorage.getItem("FeeLIst")) {
      this.formData = JSON.parse(sessionStorage.getItem("FeeLIst"));
    }
    if (sessionStorage.getItem("todoorTime")) {
      //如果有提货时间
      this.todoordate = sessionStorage.getItem("todoorTime");
    }
    if (sessionStorage.getItem("countLIst_T")) {
      //如果有选择提货费
      this.countLIst_T = JSON.parse(sessionStorage.getItem("countLIst_T"));
    }
  },
  mounted() {
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
    this.getFadata();
    this.getTidata();
    this.getSHdata();
  },
};
</script>
<style scoped>
.fontString {
  font-weight: bold;
}
.count {
  width: 100%;
  padding-top: 30px;
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.wrap_count {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.header_logo {
  width: 100%;
  float: left;
  text-align: left;
}
.morentype {
  width: 80px;
  height: 23px;
  background: #dedede;
  border-radius: 5px;
  color: #9a9a9a;
  padding: 2px;
  box-sizing: border-box;
  text-align: center;
}
.overText {
  width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.poperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #e6e6e6;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.4s;
}
.poperWrap:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
}
.thatpoperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #FF4D01;
  background: #dfdbff;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.lianxiren {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tittype {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 778px;
}
/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.popWrap_l {
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* flex-direction: column; */
}
.Item_Right {
  float: left;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.center_wrap {
  width: 1098px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 24px 28px 12px 28px;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  margin-bottom: 15px;
  overflow: hidden;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  float: left;
  width: 764px;
  background: #ffffff;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.wrap_R {
  float: right;
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
/* table 滚动条 */
.OrderDetails {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
}
.OrderDetails::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/Consignment.vue